import * as React from 'react';
import type { FeaturedProduct } from '../../types/landing';

interface WhyUsProductsProps {
  products: FeaturedProduct[];
}

export function WhyUsProducts({ products }: WhyUsProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="whyus-products">
      <style>{`
        .whyus-products {
          padding: 72px 24px;
          background: #fff;
        }
        .whyus-products-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .whyus-products h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .whyus-products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .whyus-product-card {
          background: #fafaf7;
          border-radius: 12px;
          border: 1px solid #eee;
          overflow: hidden;
          transition: box-shadow 0.2s;
        }
        .whyus-product-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        }
        .whyus-product-img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          display: block;
          background: #f5f5f5;
        }
        .whyus-product-body {
          padding: 14px 16px;
        }
        .whyus-product-cat {
          font-size: 12px;
          color: #1EAA25;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          margin: 0 0 4px;
        }
        .whyus-product-name {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0 0 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .whyus-product-price-row {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 8px;
        }
        .whyus-product-price {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          white-space: nowrap;
        }
        .whyus-product-format {
          font-size: 13px;
          color: #888;
        }
        @media (max-width: 768px) {
          .whyus-products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
          .whyus-product-img {
            height: 120px;
          }
        }
        @media (max-width: 480px) {
          .whyus-products-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
      <div className="whyus-products-inner">
        <h2>Productos frescos, seleccionados hoy</h2>
        <div className="whyus-products-grid">
          {products.map((product) => (
            <div key={product.id} className="whyus-product-card">
              <img
                className="whyus-product-img"
                src={product.webp_image_url || product.image_url}
                alt={product.title}
                loading="lazy"
              />
              <div className="whyus-product-body">
                <div className="whyus-product-name">{product.title}</div>
                {product.default_format && (
                  <div className="whyus-product-price-row">
                    <span className="whyus-product-format">
                      {product.default_format.short_name || product.default_format.name}
                    </span>
                    <span className="whyus-product-price">
                      ${product.default_format.price.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
